import { defineMutation, useMutation, useQueryCache } from '@pinia/colada';

import { getPropertyStatisticsQueryKey, portfolioQueryKey } from '@tallo/investor/property';

import { AcceptShowingRequestDto } from '../interfaces/appect-showing-request.interface';
import { showingsQueryKey } from '../queries/showings.query';
import showingRequestsService from '../services/showing-requests.service';

export const useAcceptShowingRequest = defineMutation(() => {
  return useMutation({
    mutation(payload: { propertyId: string } & AcceptShowingRequestDto) {
      return showingRequestsService.accept(payload.propertyId, {
        showingRequestId: payload.showingRequestId,
        showingAgentId: payload.showingAgentId,
      });
    },
    async onSuccess(_, payload) {
      const queryCache = useQueryCache();

      queryCache.invalidateQueries({ key: getPropertyStatisticsQueryKey(payload.propertyId) });
      queryCache.invalidateQueries({ key: [portfolioQueryKey] });
      await queryCache.invalidateQueries({ key: [showingsQueryKey] });
    },
  });
});
